














































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import SettingsPage from './SettingsPage.vue'
import PuzzleBoard from './PuzzleBoard.vue'
import PuzzleStore from './PuzzleStore.vue'
import StatBox from './StatBox.vue'
import AchievementBox from './AchievementBox.vue'
import ChallengeBox from './ChallengeBox.vue'
import NavigationPanel from './NavigationPanel.vue'
import Game from '../classes/game'

@Component({
  components: {
    PuzzleBoard,
    PuzzleStore,
    NavigationPanel,
    StatBox,
    AchievementBox,
    ChallengeBox,
    SettingsPage
  }
})
export default class MainPage extends Vue {
  @Prop() private settings!: Record<string, boolean>;
  @Prop() private hardReset!: Function;
  @Prop() private game!: Game;

  private navigator: Record<string, string>;

  constructor () {
    super()

    this.navigator = {
      location: 'sudoku'
    }
  }

  @Watch('game.puzzle')
  onChange (newPuzzle: number[][][]) {
    this.game.onPuzzleChange(newPuzzle)
  }
}
